import { connect } from 'react-redux';
import Dialog from './FieldDialog';

const mapStateToProps = ({ fieldDialog, formBuilder }) => ({
    parentMultipleMapping: fieldDialog.parentMapping,
    mappingsUsed: fieldDialog.mappingsUsed,
    multipleFieldIndex: formBuilder.multipleFieldIndex,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Dialog);
